/* esm.sh - unhead@3.1.0 */
export * from "/*unhead@3.1.0/esnext/unhead.mjs";
